// Who may manage a customer's microgrids from the Microgrids page, delete
// included. An allowlist of the app's job titles, so a missing, misspelled or
// new title gets nothing: the same three staff roles App.js lets into the
// Customers page (/customer-projects, where a customer is picked before their
// microgrids are shown). "Customer" is not on it.
export const MICROGRID_MANAGER_ROLES = Object.freeze([
  "Organization Admin",
  "Branch Admin",
  "Employee",
]);

export function mayManageMicrogrids(jobTitle) {
  return MICROGRID_MANAGER_ROLES.includes(jobTitle);
}
